module.exports = __webpack_public_path__ + "static/media/Graphik-Light.d45e03ba.woff2";